"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var js_util_1 = require("@giphy/js-util");
var react_1 = __importStar(require("react"));
var play_pause_1 = require("./controls/play-pause");
var volume_1 = require("./controls/volume");
var progress_bar_1 = __importDefault(require("./progress-bar"));
var video_1 = __importDefault(require("./video"));
var Container = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: black;\n"], ["\n    position: relative;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: black;\n"])));
var PlayPause = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var Volume = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n"])));
var Controls = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    bottom: 10px;\n    right: 10px;\n    left: 10px;\n    display: flex;\n    justify-content: space-between;\n    opacity: ", ";\n    transition: opacity ease-out 250ms;\n"], ["\n    position: absolute;\n    bottom: 10px;\n    right: 10px;\n    left: 10px;\n    display: flex;\n    justify-content: space-between;\n    opacity: ", ";\n    transition: opacity ease-out 250ms;\n"])), function (props) { return (props.isHovered ? 1 : 0); });
var VideoPlayer = function (props) {
    var width = props.width, hideMute = props.hideMute, hidePlayPause = props.hidePlayPause, hideProgressBar = props.hideProgressBar, className = props.className, persistentControls = props.persistentControls;
    var _a = react_1.useState(false), isHovered = _a[0], setIsHovered = _a[1];
    var _b = react_1.useState('paused'), playState = _b[0], setPlayState = _b[1];
    var _c = react_1.useState(null), videoEl = _c[0], _setVideoEl = _c[1];
    var _d = react_1.useState(props.muted), muted = _d[0], setMuted = _d[1];
    var _e = react_1.useState(false), mutedByBrowser = _e[0], setMutedByBrowser = _e[1];
    var onStateChange = props.onStateChange, setVideoEl = props.setVideoEl, onMuted = props.onMuted, onUserMuted = props.onUserMuted;
    var height = props.height || js_util_1.getGifHeight(props.gif, width);
    var combinedSetPlayState = react_1.useCallback(function (args) {
        onStateChange === null || onStateChange === void 0 ? void 0 : onStateChange(args);
        setPlayState(args);
    }, [onStateChange, setPlayState]);
    var combinedOnMuted = react_1.useCallback(function (args) {
        onMuted === null || onMuted === void 0 ? void 0 : onMuted(args);
        setMutedByBrowser(args);
    }, [setMutedByBrowser, onMuted]);
    var combinedSetVideoEl = react_1.useCallback(function (args) {
        setVideoEl === null || setVideoEl === void 0 ? void 0 : setVideoEl(args);
        _setVideoEl(args);
    }, [setVideoEl, _setVideoEl]);
    var toggleMute = function () {
        if (mutedByBrowser) {
            setMutedByBrowser(false);
            setMuted(false);
        }
        else {
            setMuted(!muted);
        }
    };
    react_1.useEffect(function () {
        setMuted(props.muted);
    }, [props.muted]);
    return (react_1.default.createElement(Container, { className: className, style: { width: width, height: height }, onMouseOver: function () { return setIsHovered(true); }, onMouseLeave: function () { return setIsHovered(false); } },
        react_1.default.createElement(video_1.default, __assign({}, props, { onStateChange: combinedSetPlayState, onMuted: combinedOnMuted, setVideoEl: combinedSetVideoEl, muted: muted })),
        react_1.default.createElement(Controls, { isHovered: persistentControls || isHovered },
            videoEl && !hidePlayPause ? (react_1.default.createElement(PlayPause, { onClick: function () {
                    if (playState === 'playing')
                        videoEl.pause();
                    else
                        videoEl.play();
                } }, playState === 'playing' ? react_1.default.createElement(play_pause_1.PauseIcon, null) : react_1.default.createElement(play_pause_1.PlayIcon, null))) : (react_1.default.createElement("div", null)),
            !hideMute && (react_1.default.createElement(Volume, { onClick: function (e) {
                    onUserMuted === null || onUserMuted === void 0 ? void 0 : onUserMuted(!muted);
                    e.preventDefault();
                    toggleMute();
                } }, muted || mutedByBrowser ? react_1.default.createElement(volume_1.VolumeOffIcon, null) : react_1.default.createElement(volume_1.VolumeOnIcon, null)))),
        (persistentControls || isHovered) && !hideProgressBar && videoEl ? (react_1.default.createElement(progress_bar_1.default, { videoEl: videoEl })) : null));
};
exports.default = VideoPlayer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=player.js.map